import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M75.729 34.991h-4.285v-8.552a21.433 21.433 0 1 0-42.866 0v8.552h-4.307a8.597 8.597 0 0 0-8.552 8.57V86.45A8.597 8.597 0 0 0 24.271 95H75.73a8.597 8.597 0 0 0 8.552-8.551V43.56a8.597 8.597 0 0 0-8.552-8.569zm-12.431 0H36.743v-8.552a13.287 13.287 0 0 1 26.555 0z" })
});
export default SvgLock;
